import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoicesIncomeClassificationDetailType  {
    _originalTypeClassName = "zERP.BO.InvoicesIncomeClassificationDetailType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoicesIncomeClassificationDetailType.translate = translateService;
}
this.IncomeClassificationDetailData = [];
this.Id = null;
this.LineNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
LineNumber:any;
IncomeClassificationDetailData:any;
InvoiceIncomeClassificationType:any;
static setIncomeClassificationDetailData = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeClassificationDetailData == null) $this.IncomeClassificationDetailData = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeClassificationDetailData.length > 0) {
                    Domain.InvoicesIncomeClassificationDetailType.removeIncomeClassificationDetailData($this, $this.IncomeClassificationDetailData[0]);
                }

                Domain.InvoicesIncomeClassificationDetailType.addManyIncomeClassificationDetailData($this, copyItems);
            }
static addManyIncomeClassificationDetailData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoicesIncomeClassificationDetailType.addIncomeClassificationDetailData($this, items[i]);
                }
            }
static addIncomeClassificationDetailData = ($this, item) => {
                if ($this.IncomeClassificationDetailData == null) $this.IncomeClassificationDetailData = [];
                if (item == null || $this.IncomeClassificationDetailData.indexOf(item) > -1) return;
                $this.IncomeClassificationDetailData.push(item);
if (item.InvoicesIncomeClassificationDetailType != $this) {
Domain.IncomeClassificationType.setInvoicesIncomeClassificationDetailType(item, $this);
}
}
static addRangeIncomeClassificationDetailData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoicesIncomeClassificationDetailType.addIncomeClassificationDetailData($this, item));
            }
static removeIncomeClassificationDetailData = ($this, item) => {
                if ($this == null || $this.IncomeClassificationDetailData == null || $this.IncomeClassificationDetailData.indexOf(item) === -1) return;
                var _index = $this.IncomeClassificationDetailData.indexOf(item);
                $this.IncomeClassificationDetailData.splice(_index, 1);
item.InvoicesIncomeClassificationDetailType = null;
}
static clearIncomeClassificationDetailData = ($this) => { $this.IncomeClassificationDetailData = null; }
static setInvoiceIncomeClassificationType = ($this, value) => {
var oldValue = $this.InvoiceIncomeClassificationType;
$this.InvoiceIncomeClassificationType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}